import { VznikámePack } from "../pages";
import "./Pomoc.css";
import { Helmet } from "react-helmet-async";
import Title from "../../components/Title/Title";
export default function Pomoc({ page = VznikámePack }) {
    return (
        <div id="helpContent">
            <Helmet>
                <title>Chci pomoci · ČSA</title>
                <meta name="description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta property="og:title" content="Chci pomoci · ČSA" />
                <meta property="og:description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta property="og:image" content={`${process.env.PUBLIC_URL}/assets/bannerDEJTENÁMVŠECHNYVAŠEPRACHY.png`} />
                <meta property="og:url" content="https://www.asocialove.cz/pomoc" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Chci pomoci · ČSA" />
                <meta name="twitter:description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta name="twitter:image" content={`${process.env.PUBLIC_URL}/assets/bannerDEJTENÁMVŠECHNYVAŠEPRACHY.png`} />
            </Helmet>
            {page.Title ? <page.Title /> : <Title>Chci pomoci</Title>}
            {page.NotificationsStack ? <page.NotificationsStack /> : <></>}
            <div id="helpContentWrapper">{<page.Page />}</div>
        </div>
    );
}
